module.exports = __webpack_public_path__ + "static/media/clock-black.de8c2d12.svg";